import { render, staticRenderFns } from "./FundInfoList.vue?vue&type=template&id=3542922f&scoped=true&"
import script from "./FundInfoList.vue?vue&type=script&lang=js&"
export * from "./FundInfoList.vue?vue&type=script&lang=js&"
import style0 from "./FundInfoList.vue?vue&type=style&index=0&id=3542922f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3542922f",
  null
  
)

export default component.exports